'use client';
import React from 'react';
import * as _Builtin from './_Builtin';
import * as _utils from './utils';
import _styles from './DevlinkProductSelectionSection.module.css';

export function DevlinkProductSelectionSection({ as: _Component = _Builtin.Section, serviceAction = {}, membershipAction = {} }) {
  return (
    <_Component
      className={_utils.cx(_styles, 'bg-teal-gradient')}
      grid={{
        type: 'section',
      }}
      tag="section"
    >
      <_Builtin.Block className={_utils.cx(_styles, 'position-relative')} tag="div">
        <_Builtin.Block className={_utils.cx(_styles, 'huge')} tag="div" />
        <_Builtin.Block className={_utils.cx(_styles, 'ht-container', 'md')} tag="div">
          <_Builtin.Block className={_utils.cx(_styles, 'ht-contained-hero-centered')} tag="div">
            <_Builtin.Block className={_utils.cx(_styles, 'ht-contained-hero-content')} tag="div">
              <_Builtin.Block className={_utils.cx(_styles, 'ht-hero-content')} tag="div">
                <_Builtin.Heading className={_utils.cx(_styles, 'txt-title', 'txt-n000')} tag="h2">
                  {'Human solutions for your home tech'}
                </_Builtin.Heading>
                <_Builtin.Block className={_utils.cx(_styles, 'medium-1')} tag="div" />
              </_Builtin.Block>
            </_Builtin.Block>
          </_Builtin.Block>
          <_Builtin.Block className={_utils.cx(_styles, 'col-2', 'bigger-gap')} tag="div">
            <_Builtin.Block
              className={_utils.cx(_styles, 'ht-content-item-card')}
              id={_utils.cx(_styles, 'w-node-_38009a52-e627-ce9e-5151-c49028f5c40c-28f5c401')}
              tag="div"
            >
              <_Builtin.Block className={_utils.cx(_styles, 'ht-content-item-card-img')} tag="div">
                <_Builtin.Image
                  className={_utils.cx(_styles, 'ht-inner-img')}
                  loading="lazy"
                  width="auto"
                  height="auto"
                  alt=""
                  src="https://uploads-ssl.webflow.com/5fece0d001923a6386f248d6/611b33a0d364ce2637b2d31d_04.png"
                />
              </_Builtin.Block>
              <_Builtin.Block className={_utils.cx(_styles, 'ht-content-item-card-body')} tag="div">
                <_Builtin.Heading className={_utils.cx(_styles, 'txt-header-sm')} tag="h3">
                  {'Installation & Support'}
                </_Builtin.Heading>
                <_Builtin.Block className={_utils.cx(_styles, 'tiny-1')} tag="div" />
                <_Builtin.Paragraph className={_utils.cx(_styles, 'txt-body-md')}>
                  {'Our trusted pros install, support and troubleshoot every smart device in your home—then we teach you how it all works.'}
                </_Builtin.Paragraph>
                <_Builtin.Block className={_utils.cx(_styles, 'small-2')} tag="div" />
                <_Builtin.Link
                  className={_utils.cx(_styles, 'button', 'btn-lg', 'btn-primary')}
                  button={false}
                  block="inline"
                  options={{
                    href: '#',
                  }}
                  {...serviceAction}
                >
                  <_Builtin.Block className={_utils.cx(_styles, 'button-icon-group')} tag="div">
                    <_Builtin.Block className={_utils.cx(_styles, 'button-label')} tag="div">
                      {'Browse Services'}
                    </_Builtin.Block>
                  </_Builtin.Block>
                </_Builtin.Link>
              </_Builtin.Block>
            </_Builtin.Block>
            <_Builtin.Block
              className={_utils.cx(_styles, 'ht-content-item-card')}
              id={_utils.cx(_styles, 'w-node-_38009a52-e627-ce9e-5151-c49028f5c417-28f5c401')}
              tag="div"
            >
              <_Builtin.Block className={_utils.cx(_styles, 'ht-content-item-card-img')} tag="div">
                <_Builtin.Image
                  className={_utils.cx(_styles, 'ht-inner-img')}
                  loading="lazy"
                  width="auto"
                  height="auto"
                  alt=""
                  src="https://uploads-ssl.webflow.com/5fece0d001923a6386f248d6/662c3b30a6b3b65833e1faf8_grandma-on-phone-optimized.jpg"
                />
              </_Builtin.Block>
              <_Builtin.Block className={_utils.cx(_styles, 'ht-content-item-card-body')} tag="div">
                <_Builtin.Heading className={_utils.cx(_styles, 'txt-header-sm')} tag="h3">
                  {'HelloTech Home Membership'}
                </_Builtin.Heading>
                <_Builtin.Block className={_utils.cx(_styles, 'tiny-1')} tag="div" />
                <_Builtin.Paragraph className={_utils.cx(_styles, 'txt-body-md')}>
                  {'Become a member and get personalized tech support for your connected devices'}
                </_Builtin.Paragraph>
                <_Builtin.Block className={_utils.cx(_styles, 'small-2')} tag="div" />
                <_Builtin.Link
                  className={_utils.cx(_styles, 'button', 'btn-lg', 'btn-member')}
                  button={false}
                  block="inline"
                  options={{
                    href: '#',
                  }}
                  {...membershipAction}
                >
                  <_Builtin.Block className={_utils.cx(_styles, 'button-icon-group')} tag="div">
                    <_Builtin.Block className={_utils.cx(_styles, 'button-label')} tag="div">
                      {'Learn More'}
                    </_Builtin.Block>
                  </_Builtin.Block>
                </_Builtin.Link>
              </_Builtin.Block>
            </_Builtin.Block>
          </_Builtin.Block>
        </_Builtin.Block>
        <_Builtin.Block className={_utils.cx(_styles, 'huge')} tag="div" />
        <_Builtin.Block className={_utils.cx(_styles, 'ht-bg-fill-container')} tag="div">
          <_Builtin.Image
            className={_utils.cx(_styles, 'image-57')}
            loading="lazy"
            width="auto"
            height="auto"
            alt=""
            src="https://uploads-ssl.webflow.com/5fece0d001923a6386f248d6/6604a9049660b46d146767ff_homepage-hero-bg-blob.svg"
          />
        </_Builtin.Block>
      </_Builtin.Block>
    </_Component>
  );
}
